import { Badge } from '@/shared/ui/badge';
import { Button } from '@/shared/ui/button';
import { InlineMetric } from '@/shared/ui/inline-metric';
import { Panel, PanelGroup } from '@/shared/ui/panel';
import { StatCard } from '@/shared/ui/stat-card';
import { Table, TableCell, TableHeadCell, TableRow } from '@/shared/ui/table';

const ROWS = [
  {
    id: 'P1',
    code: 'MAL-PA-26-001',
    name: 'Mallorca · Palma 8D/7N',
    status: 'confirmed',
    pax: 24,
    price: 14_990,
  },
  {
    id: 'P2',
    code: 'MAL-AL-26-002',
    name: 'Mallorca · Alcudia 8D/7N',
    status: 'pending',
    pax: 32,
    price: 15_490,
  },
  {
    id: 'P3',
    code: 'CR-RH-26-003',
    name: 'Crete · Rhodes 11D/10N',
    status: 'cancelled',
    pax: 0,
    price: 18_900,
  },
  {
    id: 'P4',
    code: 'GR-CLA-26-004',
    name: 'Greece Classical 7D/6N',
    status: 'draft',
    pax: 18,
    price: 12_750,
  },
];

const STATUS: Record<string, { label: string; tone: 'success' | 'warning' | 'danger' | 'draft' }> =
  {
    confirmed: { label: 'Confirmed', tone: 'success' },
    pending: { label: 'Pending', tone: 'warning' },
    cancelled: { label: 'Cancelled', tone: 'danger' },
    draft: { label: 'Draft', tone: 'draft' },
  };

export function CompositesSection() {
  return (
    <PanelGroup gap={12}>
      <Panel title="Stat cards" icon="trend">
        <div className="gap-phx-4 grid grid-cols-5">
          <StatCard label="Total cost" sub="(planned)" value="€ 478 990" icon="trend" size="lg" />
          <StatCard label="Bookings" value="89" tone="primary" emphasis />
          <StatCard label="Confirmed" value="62" tone="success" emphasis icon="ok" />
          <StatCard label="Pending" value="18" tone="warning" emphasis icon="alert" />
          <StatCard label="Cancelled" value="9" tone="danger" emphasis icon="x" />
        </div>
      </Panel>

      <Panel title="Inline metrics" icon="trend" variant="ghost">
        <div className="gap-phx-9 flex flex-wrap">
          <InlineMetric label="Total pax" value="245" />
          <InlineMetric label="Programme hrs" value="45.0" />
          <InlineMetric label="Series" value="14" />
          <InlineMetric label="Avg margin" value="18.4 %" />
        </div>
      </Panel>

      <Panel title="Series — bookings" icon="layers" padded={false}>
        <Table>
          <Table.Head>
            <tr>
              <TableHeadCell>Code</TableHeadCell>
              <TableHeadCell>Series</TableHeadCell>
              <TableHeadCell>Status</TableHeadCell>
              <TableHeadCell className="text-right">Pax</TableHeadCell>
              <TableHeadCell className="text-right">Price</TableHeadCell>
              <TableHeadCell className="w-[64px]" />
            </tr>
          </Table.Head>
          <Table.Body>
            {ROWS.map((row) => {
              const status = STATUS[row.status];
              return (
                <TableRow key={row.id} selected={row.id === 'P2'}>
                  <TableCell className="text-phx-sm text-phx-text-muted font-mono">
                    {row.code}
                  </TableCell>
                  <TableCell className="font-medium">{row.name}</TableCell>
                  <TableCell>
                    <Badge tone={status.tone}>{status.label}</Badge>
                  </TableCell>
                  <TableCell className="text-right tabular-nums">{row.pax}</TableCell>
                  <TableCell className="text-right tabular-nums">
                    {row.price.toLocaleString('cs-CZ')} €
                  </TableCell>
                  <TableCell className="text-right">
                    <Button variant="ghost" size="icon-sm" iconLeft="morev" aria-label="More" />
                  </TableCell>
                </TableRow>
              );
            })}
            <TableRow emphasis="strong">
              <TableCell colSpan={3}>Total</TableCell>
              <TableCell className="text-right tabular-nums">74</TableCell>
              <TableCell className="text-right tabular-nums">62 130 €</TableCell>
              <TableCell />
            </TableRow>
          </Table.Body>
        </Table>
      </Panel>
    </PanelGroup>
  );
}
